var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"complete box"},[_c('h1',{staticClass:"has-text-weight-bold"},[_vm._v("THANK YOU FOR YOUR REQUEST")]),_c('p',{staticClass:"has-text-weight-normal"},[_vm._v("Your request has been sent, someone will be in contact shortly.")])])
}]

export { render, staticRenderFns }